export default __webpack_public_path__ + "media/images/features/local_delivery/top_sp-ec93069f6b64a48db299c9abd54e57dd.png";